//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const EnableIdVerification: FeatureFlag = {"Id":"EnableIdVerification","Label":"Enable Identity Verification (manual setup required)","Impact":"Enable the Identity Verification feature","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
